require('../../modules/es6.array.is-array');
module.exports = require('../../modules/_core').Array.isArray;



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/fn/array/is-array.js
 ** module id = 208
 ** module chunks = 19
 **/